import {
  FO_ONE_DECIMAL_DISPLAY_DECIMALS,
  FO_ONE_DECIMAL_ROW_NUMBERS,
} from 'common/constants/fund-ownership';
import { FieldAttribute } from 'common/types/store';
import { getNumberValue } from 'utilities';
import { getLastColumn } from 'utilities/alphabet-utilities';
import { FIXED_DECIMAL_PLACES } from '../constants';
import { FundOwnershipCells } from '../types';

const getTotalValue = (
  rowNumber: number,
  rowAlias: string,
  cells: FundOwnershipCells,
  fundOwnershipAttrs: FieldAttribute,
  factor = 1
) => {
  const totalColumnLegend = getLastColumn(1);
  const totalCell = cells[`TOTALS_${totalColumnLegend + rowNumber}`];
  if (totalCell) {
    const decimalPlaces = FO_ONE_DECIMAL_ROW_NUMBERS.has(rowNumber)
      ? FO_ONE_DECIMAL_DISPLAY_DECIMALS
      : fundOwnershipAttrs[rowAlias]?.decimal_places ?? FIXED_DECIMAL_PLACES;
    const cellValue = Number(totalCell.value) * factor;
    return Number(cellValue.toFixed(getNumberValue(decimalPlaces)));
  }
  return 0;
};

export default getTotalValue;
